import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

import {
  computed,
  onMounted,
  PropType, ref,
} from 'vue';
import { Action, ActionParams, AlignType } from './types';
import ExpandableCell from './ExpandableCell.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleCell',
  props: {
  text: String as PropType<string>,
  align: String as PropType<AlignType>,
  action: Object as PropType<Action>,
  actionParams: Object as PropType<ActionParams>,
  width: Number as PropType<number>,
},
  emits: ['action'],
  setup(__props, { emit }) {

const props = __props





const wrapper = ref(null);
const showExpandable = ref(false);

const styles = computed(() => {
  const stylesArr = [];
  if (props.align) {
    stylesArr.push(`text-align: ${props.align}`);
  }
  if (props.width) {
    stylesArr.push(`width: ${props.width}px`);
  }
  return stylesArr;
});

const checkOverflow = () => {
  if (!wrapper.value) {
    return false;
  }
  const outerElement = wrapper.value as HTMLElement;
  const innerElement = outerElement.querySelector('span') as HTMLSpanElement;
  const outerWidth = outerElement.getBoundingClientRect().width;
  const innerWidth = innerElement.getBoundingClientRect().width;
  return innerWidth > outerWidth;
};

onMounted(() => {
  if (checkOverflow()) {
    showExpandable.value = true;
  }
});

const clickHandler = () => {
  const { action } = props;
  if (!action) {
    return;
  }
  const params = {
    name: action.name,
    type: action.type,
    customParam: props.actionParams,
  };
  emit('action', params);
};


return (_ctx: any,_cache: any) => {
  return (showExpandable.value)
    ? (_openBlock(), _createBlock(ExpandableCell, {
        key: 0,
        width: __props.width,
        text: __props.text
      }, null, 8, ["width", "text"]))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["block", {clickable: __props.action}]),
        style: _normalizeStyle(_unref(styles)),
        ref_key: "wrapper",
        ref: wrapper,
        onClick: clickHandler
      }, [
        _createElementVNode("span", null, _toDisplayString(__props.text), 1)
      ], 6))
}
}

})